import React from 'react';
import MessageRedbookNote from './message-redbook-note';
import MessageRedbookCommon from './message-redbook-common';
import MessageRedbookService from './message-redbook-service';
import MessageRedbookPurchaseComment from './message-redbook-purchase-comment';
import MessageRedbookSocial from './message-redbook-social';
import MessageRedbookLead from './message-redbook-lead';
import MessageRedbookTradeBusiness from './message-redbook-trade-business';

const MessageRedbook = props => {
  const { data = {} } = props;
  const {
    message_type, // 暂时都是 CARD
    content = {}
  } = data;
  const content_type = content.content_type;
  // 笔记类型
  if (content_type === 'note') {
    return <MessageRedbookNote data={content} />;
  }
  // 落地页
  if (content_type === 'common') {
    return <MessageRedbookCommon data={content} />;
  }
  // 服务卡片
  if (content_type === 'serviceCard') {
    return <MessageRedbookService data={content} />;
  }
  // 意向回复的评论
  if (content_type === 'purchaseComments') {
    return <MessageRedbookPurchaseComment data={content} />;
  }
  // 名片卡
  if (content_type === 'social_card') {
    return <MessageRedbookSocial data={content} />;
  }
  // 留资卡
  if (content_type === 'lead_card') {
    return <MessageRedbookLead data={content} />;
  }
  // 交易卡
  if (content_type === 'tradeBusinessCard') {
    return <MessageRedbookTradeBusiness data={content} />;
  }

  return <div></div>;
};

export default MessageRedbook;
